<template>
  <div class="list-orgs">
    <CCard>
      <CCardBody>
        <router-view v-if="isOrgRouteSelected" />

        <div v-else>
          <CCardTitle class="card-title">
            <h1>List Orgs</h1>
            <div>
              <a href="javascript:void(0)"
                 class="btn btn-outline-primary mr-2"
                 @click="() => { batchUsersModal = true }">
                Batch users adding
              </a>
              <router-link to="/orgs/add-org" tag="button" class="btn btn-outline-primary">
                Add new org
              </router-link>
            </div>
          </CCardTitle>

          <div>
            <TheTable
              :items="items"
              :fields="fields"
              @deleteItem="deleteAlert($event)"
              @edit="handleEditOrg($event)" />
          </div>
        </div>
      </CCardBody>
    </CCard>

    <!-- Modals section -->
    <!-- delete modal -->
    <TheModal
      :color="'warning'"
      :size="'sm'"
      :title="'Delete Org'"
      :showModal="deleteModal"
      :text="`Are you sure you want to delete organization: <b>${orgToDelete.organizationName}</b>.`"
      @cancel="cancel($event)"
      @okay="handleDeleteOrganization(orgToDelete)"
    />

    <!-- batch users modal -->
    <batch-users-add-modal :show.sync="batchUsersModal" />

  </div>
</template>

<script>
import getNested from "lodash-es/get";
import { mapActions } from "vuex";
import TheTable from "./../containers/TheTable";
import TheModal from "./../containers/TheModal";
import BatchUsersAddModal from "@/components/organization/modals/BatchUsersAddModal";

export default {
  name: "list-orgs",

  components: {
    BatchUsersAddModal,
    TheTable,
    TheModal,
  },

  data() {
    return {
      deleteModal: false,
      batchUsersModal: false,
      loading: false,
      apiPageSize: 1000,
      offset: 0,

      pageSize: 50,
      currentPage: 1,
      countryField: {
        value: null,
      },
      orgToDelete: {},
      items: [],
      fields: [
        { key: "organizationId", label: "Organization ID" },
        { key: "organizationName", label: "Organization Name" },
        { key: "subscriptionStart", label: "Subscription Start" },
        { key: "subscriptionEnd", label: "Subscription End" },
        { key: "emailDomains", label: "Email domains" },
        {
          key: "edit",
          label: "Edit",
          sorter: false,
          filter: false,
          _classes: "text-center",
        },
        {
          key: "delete",
          label: "Edit",
          sorter: false,
          filter: false,
          _classes: "text-center",
        },
      ],
    };
  },

  async mounted() {
    await this.getOrgData();
  },

  methods: {
    ...mapActions("users", ["listOrgs", "deleteOrg"]),

    async getOrgData() {
      this.loading = true;
      let data = await this.listOrgs();
      this.items = getNested(data, "organizations", []);
      this.loading = false;
    },

    cancel() {
      this.orgToDelete = {};
      this.deleteModal = false;
    },

    handleEditOrg(org) {
      document.querySelector(".c-body").scrollTop = 0;
      // console.log(org);
      this.$router.push({
        name: "Org Details",
        params: { org_id: org.organizationId },
      });
    },

    deleteAlert(el) {
      this.deleteModal = !this.deleteModal;
      if (this.deleteModal) this.orgToDelete = el.item;
      else this.userToDelete = {};
    },

    async handleDeleteOrganization(organization) {
      this.deleteModal = false;
      await this.deleteOrg(organization.organizationId);
      await this.getOrgData();
      this.orgToDelete = {};
    },
  },

  computed: {
    isOrgRouteSelected() {
      const routeNames = [
        'Org Details',
        'Add Org',
      ];
      return routeNames.includes(this.$route.name);
    },
  },
};
</script>

<style scoped lang="scss">
.list-orgs {
  .card-title {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h1 {
      margin: 0;
    }
  }
}
</style>
